import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useHistory, useParams } from 'react-router-dom';
import newsData from '../../data/news.json';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Detail = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const history = useHistory();
  const { id } = useParams();
  const news = newsData.news.find((n) => n.id === parseInt(id, 10));
  if (news === undefined) {
    history.push('/news');
  }
  let color = '#595f97';
  if (news?.tag === 'お知らせ') {
    color = '#49799d';
  } else if (news?.tag === 'キャンペーン') {
    color = '#2eb0a6';
  } else {
    color = '#595f97';
  }
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>ニュース詳細 | 株式会社TERRA</title>
      </Helmet>
      <div className="news">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          ニュース詳細
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/news">ニュース</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>ニュース詳細</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          {
            news ? (
              <div className="news-details item mt-5">
                <span>{news.date}</span>
                <span
                  className="label"
                  style={{
                    backgroundColor: `${color}`, color: 'white', width: '120px', display: 'inline-block', textAlign: 'center', marginLeft: '20px',
                  }}
                >
                  {' '}
                  {news.tag}
                </span>
                <h3
                  className="pt-3"
                  style={{ fontWeight: '700' }}
               // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: news.title }}
                />

                <div style={{ fontWeight: 500 }}>
                  {
                    parseInt(id, 10) ? (
                      <>
                        <div
                          style={{
                            display: 'block', margin: '30px 0', borderTop: '1px solid #cacaca', padding: '30px 0',
                          }}
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{ __html: news.content }}
                        />
                      </>
                    ) : ('')
                  }
                </div>
                <div className="d-flex flex-wrap justify-content-around">
                  <div className="py-2 py-md-5">
                    <Link
                      to="/"
                      style={{
                        height: '3rem',
                        lineHeight: '3rem',
                        background: 'rgb(46, 82, 114)',
                        color: 'white',
                        borderRadius: '1.5rem',
                        display: 'block',
                        width: '300px',
                        margin: 'auto',
                        fontSize: '1.2rem',
                        textAlign: 'center',
                      }}
                    >
                      ホームページに戻る
                    </Link>
                  </div>
                  <div className="py-2 py-md-5">
                    <Link
                      to="/news"
                      style={{
                        height: '3rem',
                        lineHeight: '3rem',
                        background: 'rgb(46, 82, 114)',
                        color: 'white',
                        borderRadius: '1.5rem',
                        display: 'block',
                        width: '300px',
                        margin: 'auto',
                        fontSize: '1.2rem',
                        textAlign: 'center',
                      }}
                    >
                      ニュース一覧はこちら
                    </Link>
                  </div>
                </div>
                <br />
                <br />
              </div>
            ) : null
          }
        </div>
      </div>
    </TheLayout>
  );
};
export default Detail;
